import { useCallback, useEffect, useRef, useState } from "react";
import api from "@/lib/api";

/**
 * GET com estados explícitos: { data, loading, error, retry, setData }.
 * Evita o padrão api.get().then() sem catch, que trava telas em
 * "Carregando..." para sempre quando a API falha.
 */
export default function useFetch(path, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const paramsRef = useRef(params);
  paramsRef.current = params;
  const key = JSON.stringify(params ?? null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    api.get(path, { params: paramsRef.current })
      .then((r) => setData(r.data))
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, key]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, retry: load, setData };
}
